import React from "react";
import { useTranslation } from "react-i18next";

const RegistrationErrorList = ({ formError, pinError, errors, customData }) => {
  const { t } = useTranslation();
  const getLabeledField = (field) => {
    try {
      if (!field) {
        return "";
      }
      return customData.find((cd) => {
        return cd.internal_name === field;
      }).label;
    } catch (e) {
      console.error(e);
      return `Error: ${e.message}`;
    }
  };

  const renderFormErrors = () => {
    if (
      formError?.some(function (error) {
        return error.name === "password";
      })
    ) {
      errors.password = { message: formError[0].message };
      return ""; // formfield error handled by PasswordValidation component
    }
    if (formError?.length > 0) {
      // Look for Generic Non-Field Errors first, and the look for Custom Data Field Errors
      // Custom Data Field Errors
      return formError.map((error) => (
        <p data-testid="registration-error" className="errorlist" key={error?.name}>
          {error.name === "non_field_errors"
            ? error?.message
            : error?.name
              ? t("registration.field_error_with_label", {
                  message: error?.message,
                  label: getLabeledField(error?.name),
                })
              : error?.message}
          <br />
        </p>
      ));
    }
    return (
      <p data-testid="registration-error" className="errorlist">
        {t("registration.error_generic")}
        <br />
      </p>
    );
  };

  return (
    <>
      {formError && renderFormErrors()}
      {pinError !== "" ? <p data-cy="error-pin">{pinError}</p> : ""}
      {errors.tos_accepted && (
        <p data-cy="error-tos">
          {" "}
          <br /> {t("registration.error_accept_tos")}
        </p>
      )}
      {Object.keys(errors).filter((x) => x !== "tos_accepted").length > 0 && <p data-cy="error-review">{t("registration.error_review")}</p>}
    </>
  );
};

export default RegistrationErrorList;
